export class SanmarOrderAcceptanceRequest {
    id:number;
    buyerPo: string;
    style: number;
    itemNo: string;
    buyer: string;
    deliveryDate:string;
    
}